import { V as p, M as A, a as F, b as w, c as W, g as ne, d as oe, e as ue, m as ie, i as ae, f as ce, h as le, j as fe, k as se, l as ye, w as z, P as pe } from "./PhoneNumberInput.lebWBEQN.js";
import { j as g } from "./jsx-runtime.DGlMoOmv.js";
import { useFormContext as be } from "react-hook-form";
import { d as me, e as ve, f as ge, b as de, g as _e } from "./Form.LdCd9gH2.js";
import { c as Oe } from "./index.CxSWpsOB.js";
var he = ";ext=", d = function(r) {
  return "([".concat(p, "]{1,").concat(r, "})");
};
function Y(e) {
  var r = "20", t = "15", n = "9", o = "6", a = "[  \\t,]*", u = "[:\\.．]?[  \\t,-]*", c = "#?", i = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", l = "(?:[xｘ#＃~～]|int|ｉｎｔ)", s = "[- ]+", b = "[  \\t]*", f = "(?:,{2}|;)", y = he + d(r), v = a + i + u + d(r) + c, Q = a + l + u + d(n) + c, ee = s + d(o) + "#", re = b + f + u + d(t) + c, te = b + "(?:,)+" + u + d(n) + c;
  return y + "|" + v + "|" + Q + "|" + ee + "|" + re + "|" + te;
}
var Pe = "[" + p + "]{" + A + "}", Ne = "[" + F + "]{0,1}(?:[" + w + "]*[" + p + "]){3,}[" + w + p + "]*", Se = new RegExp("^[" + F + "]{0,1}(?:[" + w + "]*[" + p + "]){1,2}$", "i"), we = Ne + // Phone number extensions
"(?:" + Y() + ")?", Ee = new RegExp(
  // Either a short two-digit-only phone number
  "^" + Pe + "$|^" + we + "$",
  "i"
);
function Ce(e) {
  return e.length >= A && Ee.test(e);
}
function xe(e) {
  return Se.test(e);
}
function E(e) {
  "@babel/helpers - typeof";
  return E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, E(e);
}
function je(e, r, t) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ae(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function Fe(e, r, t) {
  return r = O(r), Te(e, T() ? Reflect.construct(r, t || [], O(e).constructor) : r.apply(e, t));
}
function Te(e, r) {
  if (r && (E(r) == "object" || typeof r == "function")) return r;
  if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Re(e);
}
function Re(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ie(e, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && _(e, r);
}
function C(e) {
  var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return C = function(n) {
    if (n === null || !De(n)) return n;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (r !== void 0) {
      if (r.has(n)) return r.get(n);
      r.set(n, o);
    }
    function o() {
      return Le(n, arguments, O(this).constructor);
    }
    return o.prototype = Object.create(n.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), _(o, n);
  }, C(e);
}
function Le(e, r, t) {
  if (T()) return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, r);
  var o = new (e.bind.apply(e, n))();
  return t && _(o, t.prototype), o;
}
function T() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (T = function() {
    return !!e;
  })();
}
function De(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function _(e, r) {
  return _ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, _(e, r);
}
function O(e) {
  return O = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, O(e);
}
var m = /* @__PURE__ */ function(e) {
  function r(t) {
    var n;
    return Ae(this, r), n = Fe(this, r, [t]), Object.setPrototypeOf(n, r.prototype), n.name = n.constructor.name, n;
  }
  return Ie(r, e), je(r);
}(/* @__PURE__ */ C(Error)), R = new RegExp("(?:" + Y() + ")$", "i");
function $e(e) {
  var r = e.search(R);
  if (r < 0)
    return {};
  for (var t = e.slice(0, r), n = e.match(R), o = 1; o < n.length; ) {
    if (n[o])
      return {
        number: t,
        ext: n[o]
      };
    o++;
  }
}
var Me = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Ue(e) {
  return Me[e];
}
function He(e, r) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Be(e)) || r) {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Be(e, r) {
  if (e) {
    if (typeof e == "string") return I(e, r);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? I(e, r) : void 0;
  }
}
function I(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function L(e) {
  for (var r = "", t = He(e.split("")), n; !(n = t()).done; ) {
    var o = n.value;
    r += Ve(o, r) || "";
  }
  return r;
}
function Ve(e, r, t) {
  return e === "+" ? r ? void 0 : "+" : Ue(e);
}
function Ge(e, r) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = ke(e)) || r) {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ke(e, r) {
  if (e) {
    if (typeof e == "string") return D(e, r);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? D(e, r) : void 0;
  }
}
function D(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function Xe(e, r) {
  var t = r.countries, n = r.metadata;
  n = new W(n);
  for (var o = Ge(t), a; !(a = o()).done; ) {
    var u = a.value;
    if (n.country(u), n.leadingDigits()) {
      if (e && e.search(n.leadingDigits()) === 0)
        return u;
    } else if (ne({
      phone: e,
      country: u
    }, void 0, n.metadata))
      return u;
  }
}
function Ke(e, r) {
  var t = r.nationalNumber, n = r.metadata, o = n.getCountryCodesForCallingCode(e);
  if (o)
    return o.length === 1 ? o[0] : Xe(t, {
      countries: o,
      metadata: n.metadata
    });
}
var Z = "+", We = "[\\-\\.\\(\\)]?", $ = "([" + p + "]|" + We + ")", ze = "^\\" + Z + $ + "*[" + p + "]" + $ + "*$", Ye = new RegExp(ze, "g"), x = p, Ze = "[" + x + "]+((\\-)*[" + x + "])*", qe = "a-zA-Z", Je = "[" + qe + "]+((\\-)*[" + x + "])*", Qe = "^(" + Ze + "\\.)*" + Je + "\\.?$", er = new RegExp(Qe, "g"), M = "tel:", j = ";phone-context=", rr = ";isub=";
function tr(e) {
  var r = e.indexOf(j);
  if (r < 0)
    return null;
  var t = r + j.length;
  if (t >= e.length)
    return "";
  var n = e.indexOf(";", t);
  return n >= 0 ? e.substring(t, n) : e.substring(t);
}
function nr(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Ye.test(e) || er.test(e);
}
function or(e, r) {
  var t = r.extractFormattedPhoneNumber, n = tr(e);
  if (!nr(n))
    throw new m("NOT_A_NUMBER");
  var o;
  if (n === null)
    o = t(e) || "";
  else {
    o = "", n.charAt(0) === Z && (o += n);
    var a = e.indexOf(M), u;
    a >= 0 ? u = a + M.length : u = 0;
    var c = e.indexOf(j);
    o += e.substring(u, c);
  }
  var i = o.indexOf(rr);
  if (i > 0 && (o = o.substring(0, i)), o !== "")
    return o;
}
var ur = 250, ir = new RegExp("[" + F + p + "]"), ar = new RegExp("[^" + p + "#]+$");
function cr(e, r, t) {
  if (r = r || {}, t = new W(t), r.defaultCountry && !t.hasCountry(r.defaultCountry))
    throw r.v2 ? new m("INVALID_COUNTRY") : new Error("Unknown country: ".concat(r.defaultCountry));
  var n = fr(e, r.v2, r.extract), o = n.number, a = n.ext, u = n.error;
  if (!o) {
    if (r.v2)
      throw u === "TOO_SHORT" ? new m("TOO_SHORT") : new m("NOT_A_NUMBER");
    return {};
  }
  var c = yr(o, r.defaultCountry, r.defaultCallingCode, t), i = c.country, l = c.nationalNumber, s = c.countryCallingCode, b = c.countryCallingCodeSource, f = c.carrierCode;
  if (!t.hasSelectedNumberingPlan()) {
    if (r.v2)
      throw new m("INVALID_COUNTRY");
    return {};
  }
  if (!l || l.length < A) {
    if (r.v2)
      throw new m("TOO_SHORT");
    return {};
  }
  if (l.length > oe) {
    if (r.v2)
      throw new m("TOO_LONG");
    return {};
  }
  if (r.v2) {
    var y = new ue(s, l, t.metadata);
    return i && (y.country = i), f && (y.carrierCode = f), a && (y.ext = a), y.__countryCallingCodeSource = b, y;
  }
  var v = (r.extended ? t.hasSelectedNumberingPlan() : i) ? ie(l, t.nationalNumberPattern()) : !1;
  return r.extended ? {
    country: i,
    countryCallingCode: s,
    carrierCode: f,
    valid: v,
    possible: v ? !0 : !!(r.extended === !0 && t.possibleLengths() && ae(l, t)),
    phone: l,
    ext: a
  } : v ? sr(i, l, a) : {};
}
function lr(e, r, t) {
  if (e) {
    if (e.length > ur) {
      if (t)
        throw new m("TOO_LONG");
      return;
    }
    if (r === !1)
      return e;
    var n = e.search(ir);
    if (!(n < 0))
      return e.slice(n).replace(ar, "");
  }
}
function fr(e, r, t) {
  var n = or(e, {
    extractFormattedPhoneNumber: function(u) {
      return lr(u, t, r);
    }
  });
  if (!n)
    return {};
  if (!Ce(n))
    return xe(n) ? {
      error: "TOO_SHORT"
    } : {};
  var o = $e(n);
  return o.ext ? o : {
    number: n
  };
}
function sr(e, r, t) {
  var n = {
    country: e,
    phone: r
  };
  return t && (n.ext = t), n;
}
function yr(e, r, t, n) {
  var o = ce(L(e), r, t, n.metadata), a = o.countryCallingCodeSource, u = o.countryCallingCode, c = o.number, i;
  if (u)
    n.selectNumberingPlan(u);
  else if (c && (r || t))
    n.selectNumberingPlan(r, t), r && (i = r), u = t || le(r, n.metadata);
  else return {};
  if (!c)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: u
    };
  var l = fe(L(c), n), s = l.nationalNumber, b = l.carrierCode, f = Ke(u, {
    nationalNumber: s,
    metadata: n
  });
  return f && (i = f, f === "001" || n.country(i)), {
    country: i,
    countryCallingCode: u,
    countryCallingCodeSource: a,
    nationalNumber: s,
    carrierCode: b
  };
}
function h(e) {
  "@babel/helpers - typeof";
  return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, h(e);
}
function U(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function H(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? U(Object(t), !0).forEach(function(n) {
      pr(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : U(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function pr(e, r, t) {
  return (r = br(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function br(e) {
  var r = mr(e, "string");
  return h(r) == "symbol" ? r : r + "";
}
function mr(e, r) {
  if (h(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (h(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function vr(e, r, t) {
  return cr(e, H(H({}, r), {}, {
    v2: !0
  }), t);
}
function P(e) {
  "@babel/helpers - typeof";
  return P = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, P(e);
}
function B(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function gr(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? B(Object(t), !0).forEach(function(n) {
      dr(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : B(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function dr(e, r, t) {
  return (r = _r(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function _r(e) {
  var r = Or(e, "string");
  return P(r) == "symbol" ? r : r + "";
}
function Or(e, r) {
  if (P(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (P(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function hr(e, r) {
  return wr(e) || Sr(e, r) || Nr(e, r) || Pr();
}
function Pr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Nr(e, r) {
  if (e) {
    if (typeof e == "string") return V(e, r);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? V(e, r) : void 0;
  }
}
function V(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function Sr(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n, o, a, u, c = [], i = !0, l = !1;
    try {
      if (a = (t = t.call(e)).next, r !== 0) for (; !(i = (n = a.call(t)).done) && (c.push(n.value), c.length !== r); i = !0) ;
    } catch (s) {
      l = !0, o = s;
    } finally {
      try {
        if (!i && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (l) throw o;
      }
    }
    return c;
  }
}
function wr(e) {
  if (Array.isArray(e)) return e;
}
function q(e) {
  var r = Array.prototype.slice.call(e), t = hr(r, 4), n = t[0], o = t[1], a = t[2], u = t[3], c, i, l;
  if (typeof n == "string")
    c = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    u ? (i = a, l = u) : (i = void 0, l = a), o && (i = gr({
      defaultCountry: o
    }, i));
  else if (se(o))
    a ? (i = o, l = a) : l = o;
  else throw new Error("Invalid second argument: ".concat(o));
  return {
    text: c,
    options: i,
    metadata: l
  };
}
function N(e) {
  "@babel/helpers - typeof";
  return N = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, N(e);
}
function G(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function k(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? G(Object(t), !0).forEach(function(n) {
      Er(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : G(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Er(e, r, t) {
  return (r = Cr(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Cr(e) {
  var r = xr(e, "string");
  return N(r) == "symbol" ? r : r + "";
}
function xr(e, r) {
  if (N(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (N(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function J(e, r, t) {
  r && r.defaultCountry && !ye(r.defaultCountry, t) && (r = k(k({}, r), {}, {
    defaultCountry: void 0
  }));
  try {
    return vr(e, r, t);
  } catch (n) {
    if (!(n instanceof m)) throw n;
  }
}
function jr() {
  var e = q(arguments), r = e.text, t = e.options, n = e.metadata;
  return J(r, t, n);
}
function S(e) {
  "@babel/helpers - typeof";
  return S = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, S(e);
}
function X(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function K(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? X(Object(t), !0).forEach(function(n) {
      Ar(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : X(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Ar(e, r, t) {
  return (r = Fr(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Fr(e) {
  var r = Tr(e, "string");
  return S(r) == "symbol" ? r : r + "";
}
function Tr(e, r) {
  if (S(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (S(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Rr() {
  var e = q(arguments), r = e.text, t = e.options, n = e.metadata;
  t = K(K({}, t), {}, {
    extract: !1
  });
  var o = J(r, t, n);
  return o && o.isValid() || !1;
}
function Ir() {
  return z(jr, arguments);
}
function Hr() {
  return z(Rr, arguments);
}
const Br = ({
  name: e,
  className: r,
  inputClassName: t,
  label: n,
  subcopy: o,
  note: a,
  required: u,
  ...c
}) => {
  const {
    control: i,
    setValue: l
  } = be();
  return /* @__PURE__ */ g.jsx(me, { control: i, name: e, render: ({
    field: s
  }) => /* @__PURE__ */ g.jsxs(ve, { disabled: c.disabled, className: Oe({
    "tw-w-full tw-flex-1": c.fullWidth
  }, r), children: [
    !!n && /* @__PURE__ */ g.jsx(ge, { subcopy: o, required: u, children: n }),
    /* @__PURE__ */ g.jsx(de, { forwardErrorMsg: !0, children: /* @__PURE__ */ g.jsx(pe, { className: t, ...c, ...s, onChange: (b, f) => {
      const y = Ir(b), v = y ? y.nationalNumber : "";
      s.onChange(f.inputValue ? b : ""), l(`${e}_number`, v), l(`${e}_country`, f.country.iso2), l(`${e}_country_code`, f.country.dialCode);
    }, ref: null }) }),
    /* @__PURE__ */ g.jsx(_e, { children: a })
  ] }) });
};
export {
  Br as P,
  Hr as i,
  Ir as p
};
//# sourceMappingURL=PhoneNumberInputField.BHIlEyO_.js.map
